import {
    FETCH_STATUS,
    FETCH_CURRENT,
    ACCEPT_TERMS, ACCEPT_TERMS_SUCCESS,
} from './TermsActionTypes';
import { switchMap, map, catchError } from 'rxjs/operators';
import { combineEpics } from 'redux-observable';
import config from 'react-global-configuration';
import { termsActions } from './'
import {
    getJsonWithAuth,
    postJsonWithAuth,
    errorHandlingWithLogoutCheck,
} from "../../../components/AjaxHelpers";

export const termsEpics = combineEpics(

    (action$, state$) => action$.ofType(FETCH_STATUS).pipe(
        switchMap(action =>
            getJsonWithAuth({
                url: config.get('apiBaseUrl') + '/terms/v1/status',
                state: state$.value
            }).pipe(
                map(payload => termsActions.fetchStatusSucceeded(payload)),
                catchError(response => errorHandlingWithLogoutCheck(response, [termsActions.fetchStatusFailed(response)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(FETCH_CURRENT).pipe(
        switchMap(action =>
            getJsonWithAuth({
                url: config.get('apiBaseUrl') + '/terms/v1/current',
                state: state$.value
            }).pipe(
                map(payload => termsActions.fetchCurrentSucceeded(payload)),
                catchError(response => errorHandlingWithLogoutCheck(response, [termsActions.fetchCurrentFailed(response)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(ACCEPT_TERMS).pipe(
        switchMap(action =>
            postJsonWithAuth({
                url: config.get('apiBaseUrl') + '/terms/v1/accept',
                body: {
                    termsDocumentId: action.termsDocumentId,
                },
                state: state$.value
            }).pipe(
                map(payload => termsActions.acceptTermsSucceeded()),
                catchError(response => errorHandlingWithLogoutCheck(response, [termsActions.acceptTermsFailed(response)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(ACCEPT_TERMS_SUCCESS).pipe(
        map(action => termsActions.fetchStatus())
    ),

);
